@use '@design/design-tokens/border-radius/border-radius' as *;

.buttonsWrapper {
  position: absolute;
  right: 0;
  max-width: 215px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px;
  @include border-radius-r2;
  border: 1px solid var(--border-soft);
  background-color: var(--background-soft);
}

.scheduleButton {
  &:disabled {
    border: none;
  }
}
